@if (dataLoading()) {<app-progress></app-progress>};

<div class="page-content">
    <div class="container-fluid">

        <div class="row mb-3">
            <div class="col-12">
                <div class="d-flex align-items-center justify-content-between bg-white p-3 rounded shadow-sm">
                    <div>
                        <h4 class="mb-1 text-primary">{{ action().MenuTitle }}</h4>
                        <p class="text-muted mb-0 small">{{ action().ParentMenuTitle }} / {{ action().MenuTitle }}</p>
                    </div>
                    <button mat-stroked-button color="primary" routerLink="/admin/admin-dashboard">
                        <i class="bx bx-home-alt me-1"></i> Dashboard
                    </button>
                </div>
            </div>
        </div>

        <form #formExtraCharge="ngForm">
            <div class="row">
                <div class="col-xl-4">
                    <div class="card border-0 shadow-sm mb-4">
                        <div class="card-header bg-transparent border-bottom">
                            <h5 class="card-title mb-0"><i class="bx bx-cog me-2 text-primary"></i>Configuration</h5>
                        </div>
                        <div class="card-body px-3 py-3">
                            <div class="row g-3">

                                <!-- Destination -->
                                <div class="col-12">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Destination</mat-label>
                                        <mat-select name="SelectedDestinationId" [(ngModel)]="SelectedDestinationId"
                                            (ngModelChange)="onFormDestinationChange()" required>
                                            @for (dest of DestinationList(); track dest.DestinationId) {
                                            <mat-option [value]="dest.DestinationId">{{ dest.DestinationName
                                                }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <!-- Location -->
                                <div class="col-12">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Location</mat-label>
                                        <mat-select name="SelectedLocationId" [(ngModel)]="SelectedLocationId"
                                            (ngModelChange)="onFormLocationChange()" required>
                                            @for (loc of LocationList(); track loc.LocationId) {
                                            <mat-option [value]="loc.LocationId">{{ loc.LocationName }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <!-- Hotel -->
                                <div class="col-12">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Select Hotel</mat-label>
                                        <mat-select #HotelId="ngModel" name="HotelId" [(ngModel)]="ExtraCharge.HotelId"
                                            (ngModelChange)="onHotelChange()" required>
                                            @for (dest of FilteredHotelList(); track dest.HotelId) {
                                            <mat-option [value]="dest.HotelId">{{ dest.HotelName }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <!-- From & To Date -->
                                <div class="col-6">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>From Date</mat-label>
                                        <input matInput [matDatepicker]="fromPicker" name="FromDate"
                                            [(ngModel)]="ExtraCharge.FromDate" required>
                                        <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
                                        <mat-datepicker #fromPicker></mat-datepicker>
                                    </mat-form-field>
                                </div>

                                <div class="col-6">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>To Date</mat-label>
                                        <input matInput [matDatepicker]="toPicker" name="ToDate"
                                            [(ngModel)]="ExtraCharge.ToDate" required [min]="ExtraCharge.FromDate">
                                        <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
                                        <mat-datepicker #toPicker></mat-datepicker>
                                    </mat-form-field>
                                </div>

                                <!-- Status -->
                                <div class="col-12">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Status</mat-label>
                                        <mat-select name="Status" [(ngModel)]="ExtraCharge.Status" required>
                                            @for (status of StatusList; track status.Key) {
                                            <mat-option [value]="status.Key">{{ status.Value }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-8">
                    @if (showRoomTypeError()) {
                    <div class="alert alert-danger mb-3 border-0 shadow-sm d-flex align-items-center">
                        <i class="bx bx-error-circle me-2 fs-4"></i>
                        No room type available for this hotel.
                    </div>
                    }

                    <div class="card border-0 shadow-sm mb-4">
                        <div
                            class="card-header bg-transparent border-bottom d-flex justify-content-between align-items-center">
                            <h5 class="card-title mb-0"><i class="bx bx-money me-2 text-success"></i>Define Rates</h5>
                            <span class="badge bg-soft-info text-info p-2">{{ ExtraCharge.HotelCategoryName || 'No
                                Category' }}</span>
                        </div>
                        <div class="card-body bg-light-subtle">
                            <div class="row g-3">


                                <div class="col-md-4">
                                    <div class="p-3 bg-white border rounded shadow-sm">
                                        <h6 class="text-primary border-bottom pb-2 mb-3">AWEB</h6>
                                        <mat-form-field appearance="outline" class="w-100 mb-2">
                                            <mat-label>CP Rate</mat-label>
                                            <input matInput name="AWeb_CpRate" [(ngModel)]="AWebRates.CpRate"
                                                type="number">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="w-100 mb-2">
                                            <mat-label>MAP Rate</mat-label>
                                            <input matInput name="AWeb_MapRate" [(ngModel)]="AWebRates.MapRate"
                                                type="number">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="w-100">
                                            <mat-label>AP Rate</mat-label>
                                            <input matInput name="AWeb_ApRate" [(ngModel)]="AWebRates.ApRate"
                                                type="number">
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="p-3 bg-white border rounded shadow-sm">
                                        <h6 class="text-primary border-bottom pb-2 mb-3">CWEB</h6>
                                        <mat-form-field appearance="outline" class="w-100 mb-2 small-input">
                                            <mat-label>CP Rate</mat-label>
                                            <input matInput name="CWeb_CpRate" [(ngModel)]="CWebRates.CpRate"
                                                type="number">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="w-100 mb-2">
                                            <mat-label>MAP Rate</mat-label>
                                            <input matInput name="CWeb_MapRate" [(ngModel)]="CWebRates.MapRate"
                                                type="number">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="w-100">
                                            <mat-label>AP Rate</mat-label>
                                            <input matInput name="CWeb_ApRate" [(ngModel)]="CWebRates.ApRate"
                                                type="number">
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="p-3 bg-white border rounded shadow-sm">
                                        <h6 class="text-primary border-bottom pb-2 mb-3">CNB</h6>
                                        <mat-form-field appearance="outline" class="w-100 mb-2">
                                            <mat-label>CP Rate</mat-label>
                                            <input matInput name="CNB_CpRate" [(ngModel)]="CNBRates.CpRate"
                                                type="number">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="w-100 mb-2">
                                            <mat-label>MAP Rate</mat-label>
                                            <input matInput name="CNB_MapRate" [(ngModel)]="CNBRates.MapRate"
                                                type="number">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="w-100">
                                            <mat-label>AP Rate</mat-label>
                                            <input matInput name="CNB_ApRate" [(ngModel)]="CNBRates.ApRate"
                                                type="number">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-4 d-flex justify-content-end gap-2">
                                @if (editingRowIndex !== null) {
                                <button mat-button color="warn" (click)="cancelEdit()">Cancel</button>
                                }
                                <button mat-raised-button color="primary" class="px-4" (click)="addToTable()">
                                    <i class="bx {{ editingRowIndex !== null ? 'bx-check' : 'bx-plus' }} me-1"></i>
                                    {{ editingRowIndex !== null ? 'Update Entry' : 'Add to Preview' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <div class="row">
            <div class="col-12">
                <div class="card border-0 shadow-sm">
                    <div
                        class="card-header bg-transparent border-bottom d-flex justify-content-between align-items-center">
                        <h5 class="card-title mb-0">Charge Summary List</h5>
                        <!-- @if (ExtraChargeRows().length > 0) {
                            <button mat-raised-button color="accent" (click)="saveExtraCharges()">
                                <i class="bx bx-save me-1"></i> Finalize & Save All
                            </button>
                        } -->
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table align-middle table-hover border-light">
                                <thead class="table-light">
                                    <tr>
                                        <th class="text-center" style="width: 50px;">#</th>
                                        <th>Hotel / Category</th>
                                        <th>Type</th>
                                        <th>Validity</th>
                                        <th class="text-center">CP</th>
                                        <th class="text-center">MAP</th>
                                        <th class="text-center">AP</th>
                                        <th>Status</th>
                                        <th class="text-end">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (row of ExtraChargeRows(); track $index; let i = $index) {
                                    <tr>
                                        <td class="text-center text-muted">{{ i + 1 }}</td>
                                        <td>
                                            <div class="fw-bold">{{ row.HotelName }}</div>
                                            <small class="text-muted">{{ row.HotelCategoryName }}</small>
                                        </td>
                                        <td><span class="badge bg-soft-primary text-primary">{{ row.ChargeTypeName
                                                }}</span></td>
                                        <td>
                                            <div class="small">
                                                {{ row.FromDate | date:'dd MMM yy' }}
                                                <br>
                                                {{ row.ToDate |
                                                date:'dd MMM yy' }}
                                            </div>
                                        </td>
                                        <td class="text-center fw-medium">{{ row.CpRate }}</td>
                                        <td class="text-center fw-medium">{{ row.MapRate }}</td>
                                        <td class="text-center fw-medium">{{ row.ApRate }}</td>
                                        <td>
                                            <span class="badge"
                                                [ngClass]="row.Status === 1 ? 'bg-success' : 'bg-danger'">
                                                {{ AllStatusList[row.Status] }}
                                            </span>
                                        </td>
                                        <td class="text-end">
                                            <button mat-icon-button class="text-success" (click)="editRow(i)">
                                                <i class="bx bxs-edit-alt fs-5"></i>
                                            </button>
                                            <button mat-icon-button class="text-danger" (click)="removeRow(i)">
                                                <i class="bx bxs-trash fs-5"></i>
                                            </button>
                                        </td>
                                    </tr>
                                    } @empty {
                                    <tr>
                                        <td colspan="9" class="text-center py-5 text-muted">
                                            <i class="bx bx-file-blank fs-1 d-block mb-2"></i>
                                            No charges added to the list yet.
                                        </td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div class="col-sm-12 text-end">
                            @if (ExtraChargeRows().length > 0) {
                            <button mat-raised-button color="accent" (click)="saveExtraCharges()">
                                <i class="bx bx-save me-1"></i> Finalize & Save All
                            </button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>